import { PaymentOrder } from '@/api/payment-orders';

export default {
  post(paymentOrder: PaymentOrder) {
    return paymentOrder;
  },
};
